import http from '../http'
import * as types from '../mutation-types';
import { serialize } from 'object-to-formdata';

export const state = {
    status: '',
    image: null
};

export const getters = {
    loadStatus: state => state.status,
    image: state => state.image
};

export const mutations = {
    /** STORE */
    [types.UPLOAD_IMAGE_ERROR](state) {
        state.status = 'error';
    },
    [types.UPLOAD_IMAGE_SUCCESS](state, {data}) {
        state.status = 'success';
        state.image = data
    },
    [types.UPLOAD_IMAGE_LOADING](state) {
        state.status = 'loading';
    },
};

export const actions = {
    async image({commit}, image) {
        return new Promise((resolve, reject) => {
            commit(types.UPLOAD_IMAGE_LOADING);
            let formData = new FormData;
            formData.append('image', image);
            http.post('upload', formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }).then(({data}) => {
                commit(types.UPLOAD_IMAGE_SUCCESS, data)
                resolve(data)
            }).catch(({response}) => {
                commit(types.UPLOAD_IMAGE_ERROR)
                reject(response.data)
            })
        })
    },
};
